if (!customElements.get('cotw-category-showcase')) {
 customElements.define('cotw-category-showcase', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.tabs = [...this.querySelectorAll('[role="tab"]')];
   this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
   if (!this.tabs.length) return;
   this.index = 0;
   this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches || !!window.Shopify?.designMode;
   this.pause = this.querySelector('.cotw-showcase__pause');
   this.querySelector('[role="tablist"]').hidden = false;
   this.pause.hidden = this.tabs.length < 2;
   this.select(0);
   this.updatePause();
   this.tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => { this.paused = true; this.updatePause(); this.select(index); });
    tab.addEventListener('keydown', event => {
     let next;
     if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
     if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
     if (event.key === 'Home') next = 0;
     if (event.key === 'End') next = this.tabs.length - 1;
     if (next === undefined) return;
     event.preventDefault(); this.tabs[next].click(); this.tabs[next].focus();
    });
   });
   this.pause.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); });
   this.timer = setInterval(() => {
    const rect = this.getBoundingClientRect();
    if (this.paused || document.hidden || this.querySelector('.card-wrapper:hover') || this.querySelector('.cotw-showcase__panel:focus-within') || rect.bottom < 0 || rect.top > innerHeight) return;
    this.select((this.index + 1) % this.tabs.length);
   }, 5000);
  }
  select(index) {
   this.index = index;
   this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
   this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
  }
  updatePause() { this.pause.textContent = this.paused ? 'Resume rotation' : 'Pause rotation'; }
  disconnectedCallback() { clearInterval(this.timer); this.ready = false; }
 });
}
